import {getCancellationFilterId} from './filters';
import {
    FREE_CANCEL_60_DAYS_ID,
    FREE_CANCEL_30_DAYS_ID,
    FREE_CANCEL_14_DAYS_ID,
} from '../constants/filters';

type SearchFilter = {
    name: string;
    checked: boolean;
};

export type CheckboxFilter = {
    filterId: string;
    isChecked: boolean;
    isDisabled: boolean;
    label: string;
    idsCheckedOnSelect: string[];
    idsCheckedOnDeselect: string[];
};

export const selectCheckboxes = (
    filtersCheckboxes: CheckboxFilter[],
    filterId: string | null
) => {
    if (!filterId) {
        return filtersCheckboxes;
    }
    const checkboxesState = filtersCheckboxes.find((item) => {
        return item.filterId === filterId;
    });
    filtersCheckboxes.forEach((filter) => {
        if (checkboxesState) {
            filter.isChecked =
                !filter.isDisabled &&
                checkboxesState.idsCheckedOnSelect.includes(filter.filterId);
        }
    });
    return filtersCheckboxes;
};

export const unselectCheckboxes = (
    filtersCheckboxes: CheckboxFilter[],
    filterId: string | null
) => {
    if (!filterId) {
        return filtersCheckboxes;
    }
    const checkboxesState = filtersCheckboxes.find((item) => {
        return item.filterId === filterId;
    });
    filtersCheckboxes.forEach((filter) => {
        if (checkboxesState) {
            filter.isChecked =
                !filter.isDisabled &&
                checkboxesState.idsCheckedOnDeselect.includes(filter.filterId);
        }
    });
    return filtersCheckboxes;
};

export const getCheckboxLineClassName = (
    filters: CheckboxFilter[],
    index: number,
    isChecked: boolean,
    isDisabled: boolean
) => {
    if (index === filters.length - 1) {
        return '';
    }

    if (isDisabled) {
        return 'disabledLine';
    }

    if (isChecked) {
        return 'activeLine';
    }

    return 'inactiveLine';
};

export const filtersCheckboxesDefs = {
    [FREE_CANCEL_14_DAYS_ID]: {
        idsCheckedOnSelect: [FREE_CANCEL_14_DAYS_ID],
        idsCheckedOnDeselect: [],
    },
    [FREE_CANCEL_30_DAYS_ID]: {
        idsCheckedOnSelect: [FREE_CANCEL_14_DAYS_ID, FREE_CANCEL_30_DAYS_ID],
        idsCheckedOnDeselect: [FREE_CANCEL_14_DAYS_ID],
    },
    [FREE_CANCEL_60_DAYS_ID]: {
        idsCheckedOnSelect: [
            FREE_CANCEL_14_DAYS_ID,
            FREE_CANCEL_30_DAYS_ID,
            FREE_CANCEL_60_DAYS_ID,
        ],
        idsCheckedOnDeselect: [FREE_CANCEL_14_DAYS_ID, FREE_CANCEL_30_DAYS_ID],
    },
};

export const updateSearchFilters = (
    filtersCheckboxes,
    updateMultipleFilterCheck
) => {
    // get first selected filter
    const selectedFilterIndex = filtersCheckboxes.findIndex((filter) => {
        return filter.isChecked;
    });
    const filtersArr: SearchFilter[] = [];
    // only the strongest cancellation filter will be applied to search url
    // updating state for all 3 filters by dispatching redux action
    filtersCheckboxes.forEach((filter, index) => {
        if (selectedFilterIndex === index) {
            filtersArr.push({
                name: filter.filterId,
                checked: true,
            });
        } else {
            filtersArr.push({
                name: filter.filterId,
                checked: false,
            });
        }
    });

    updateMultipleFilterCheck(filtersArr);
};

export const getFiltersWithSelection = (cancellationFilters, searchFilters) => {
    // get cancellation filter id from url
    const cancellationFilterId = getCancellationFilterId(searchFilters);
    const filtersCheckboxes = cancellationFilters.map((filter) => {
        const {checked, count, filter: filterDescription} = filter;
        const filterId = filterDescription.refineByQueryArgument;
        return {
            isDisabled: !checked && count <= 2,
            isChecked: false,
            label: filterDescription.name,
            filterId,
            ...filtersCheckboxesDefs[filterId],
        };
    });
    // select checkboxes for the corresponding cancellation filters
    return selectCheckboxes(filtersCheckboxes, cancellationFilterId);
};
